import { render, staticRenderFns } from "./PalestraReservationEditor.vue?vue&type=template&id=732bcc34&scoped=true&"
import script from "./PalestraReservationEditor.vue?vue&type=script&lang=js&"
export * from "./PalestraReservationEditor.vue?vue&type=script&lang=js&"
import style0 from "./PalestraReservationEditor.vue?vue&type=style&index=0&id=732bcc34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732bcc34",
  null
  
)

export default component.exports